module.exports = __webpack_public_path__ + "media/images/favicon/favicon-020dd26c47b16d40a32e4d81754211bf.ico";